import { baseApi } from "@/services/api/baseApi";
import { extractPagination, mapInvoiceRow } from "@/services/invoices/invoiceMappers";
import { buildApprovalRequestQuery } from "@/services/invoices/invoiceQueryParams";

export const approvalsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Invoices waiting for the current user's sign-off. */
    getApprovalRequests: builder.query({
      query: (args) => `/invoices/to-approve?${buildApprovalRequestQuery(args)}`,
      transformResponse: (response, _meta, arg) => ({
        items: (response?.items ?? []).map((item) => mapInvoiceRow(item, arg?.currentUserGuid)),
        pagination: extractPagination(response),
      }),
      providesTags: (result) => [
        { type: "ApprovalRequests", id: "LIST" },
        ...(result?.items ?? []).map((item) => ({ type: "ApprovalRequests", id: item.id })),
      ],
    }),

    /* --------------------------------------------------------------- rules */

    getApprovalRules: builder.query({
      query: () => "/invoices/approval-rules",
      transformResponse: (response) =>
        (response ?? []).map((rule, index) => ({ ...rule, ruleNumber: index + 1 })),
      providesTags: (result) => [
        { type: "ApprovalRules", id: "LIST" },
        ...(result ?? []).map((rule) => ({ type: "ApprovalRules", id: rule.guid })),
      ],
    }),

    getApprovalRuleFields: builder.query({
      query: () => "/invoices/approval-rules/fields",
      providesTags: [{ type: "ApprovalRulesFields", id: "LIST" }],
    }),

    createApprovalRule: builder.mutation({
      query: (data) => ({
        url: "/invoices/approval-rules",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "ApprovalRules", id: "LIST" }],
    }),

    updateApprovalRule: builder.mutation({
      query: (data) => ({
        url: `/invoices/approval-rules/${data.guid}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [{ type: "ApprovalRules", id: "LIST" }],
    }),

    deleteApprovalRule: builder.mutation({
      query: (guid) => ({
        url: `/invoices/approval-rules/${guid}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "ApprovalRules", id: "LIST" }],
    }),
  }),
});

export const {
  useGetApprovalRequestsQuery,
  useGetApprovalRulesQuery,
  useGetApprovalRuleFieldsQuery,
  useCreateApprovalRuleMutation,
  useUpdateApprovalRuleMutation,
  useDeleteApprovalRuleMutation,
} = approvalsApi;
